module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-right-top-metals-remnants.5dace791.png";